const includes = require('lodash/includes');
const range = require('lodash/range');

const DEFAULT_CONFIG = {
  QUANTITIES: range(1, 21, 1),
  MIN: 1,
  MAX: 999,
  SHOW_INPUT_BUTTONS: false
};

const inject = [
  '$scope',
  'ogsdk.subscriptionService',
  'ogsdk.itemService',
  'toastService',
  '$q',
  'quantityControl'
];

function QuantityControlControllerFactory(
  $scope,
  subscriptionService,
  itemService,
  toastService,
  $q,
  quantityControl
) {
  class QuantityControlController {
    constructor() {
      this.loading = false;
      this.quantities = quantityControl.quantities || DEFAULT_CONFIG.QUANTITIES;
      this.showInputButtons = quantityControl.showInputButtons || DEFAULT_CONFIG.SHOW_INPUT_BUTTONS;
      this.templateUrl = quantityControl.templateUrl;
      this.qtyType = quantityControl.type;
      this.minQuantity = quantityControl.min || DEFAULT_CONFIG.MIN;
      this.maxQuantity = quantityControl.max || DEFAULT_CONFIG.MAX;
      this.item = { previousQty: 0 };
    }

    $onInit() {
      this.buttonsAllowed = this.showInputButtons;
      this.decreaseButtonBlocked = (this.item.quantity <= this.minQuantity);
      this.increaseButtonBlocked = (this.item.quantity >= this.maxQuantity);
    }

    onQtyFocus(quantity) {
      // saves quantity on focus for validations on qty update
      this.item.previousQty = quantity;
    }

    updateQuantity(item, quantity) {
      const newQuantity = parseInt(quantity, 10);

      // invalid if quantity is not a number, or a negative number
      let invalidQtyValue;

      if (this.qtyType === 'input') {
        invalidQtyValue = !newQuantity || newQuantity < this.minQuantity || newQuantity > this.maxQuantity;
      }
      else {
        invalidQtyValue = !includes(this.quantities, newQuantity);
      }

      // if invalid or greater than maximum... fallback to previous qty
      if (invalidQtyValue || newQuantity === this.item.previousQty) {
        this.item.quantity = this.item.previousQty || this.item.quantity;
        return this.item.previousQty;
      }

      const deferred = $q.defer();
      try {
        if (!this.loading) {
          this.loading = true;

          if (item.subscription) {
            deferred.resolve(subscriptionService.changeQuantity(item.subscription.publicId, newQuantity));
          }
          else {
            deferred.resolve(itemService.changeQuantity(item.publicId, newQuantity));
          }
        }
        else {
          deferred.reject('Already loading');
        }
      }
      catch (err) {
        deferred.reject(err);
      }

      return deferred.promise
        .then(() => {
          const locale = item.subscription ? 'TOAST_QUANTITY_UPDATE_SUCCESS_SUBSCRIPTION' : 'TOAST_QUANTITY_UPDATE_SUCCESS_ONE_TIME';
          toastService.translate.success(locale, { quantity: newQuantity });
        })
        .then(() => $scope.$emit('ogOnQuantityChange'))
        .catch(() => {
          const error = item.subscription ? 'TOAST_QUANTITY_UPDATE_DANGER_SUBSCRIPTION'
            : 'TOAST_QUANTITY_UPDATE_DANGER_ONE_TIME';
          toastService.translate.danger(error, { quantity: newQuantity });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  return new QuantityControlController();
}


QuantityControlControllerFactory.$inject = inject;

module.exports = {
  module: angular.module('msi.quantity.controller', []).name,
  name: 'QuantityControlController'
};

angular.module(module.exports.module)
  .controller(module.exports.name, QuantityControlControllerFactory);
